import React from "react";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import { ProgressSpinner } from "primereact/progressspinner";

const formatTime = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  const now = new Date();
  const diff = (now - date) / 1000;
  if (diff < 60) return "now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
  return date.toLocaleDateString();
};

const ConversationList = ({ conversations, activeId, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="conversation-list-loading">
        <ProgressSpinner style={{ width: "30px", height: "30px" }} />
      </div>
    );
  }

  if (!conversations || conversations.length === 0) {
    return (
      <div className="conversation-list-empty">
        <i className="pi pi-inbox" style={{ fontSize: "2rem", opacity: 0.3 }}></i>
        <p>No conversations yet</p>
      </div>
    );
  }

  return (
    <ul className="conversation-list">
      {conversations.map((conv) => {
        const otherParticipants = (conv.participants || []).filter((p) => !p.isSelf);
        const other = otherParticipants[0]?.user;
        const displayName = conv.title || other?.name || "Conversation";
        const initials = displayName
          .split(" ")
          .map((s) => s[0])
          .filter(Boolean)
          .slice(0, 2)
          .join("")
          .toUpperCase();

        return (
          <li
            key={conv.id}
            className={`conversation-item ${activeId === conv.id ? "active" : ""}`}
            onClick={() => onSelect(conv)}
          >
            <Avatar label={initials} shape="circle" className="conversation-avatar" />
            <div className="conversation-info">
              <div className="conversation-top">
                <span className="conversation-name">{displayName}</span>
                <span className="conversation-time">{formatTime(conv.last_message_at || conv.updatedAt)}</span>
              </div>
              <div className="conversation-bottom">
                <span className="conversation-preview">
                  {conv.last_message_preview || "No messages yet"}
                </span>
                {conv.unreadCount > 0 && (
                  <Badge value={conv.unreadCount} severity="danger" />
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ConversationList;
